import { render, staticRenderFns } from "./NudgeManager.vue?vue&type=template&id=1b6c3e48&scoped=true"
import script from "./NudgeManager.vue?vue&type=script&lang=js"
export * from "./NudgeManager.vue?vue&type=script&lang=js"
import style0 from "./NudgeManager.vue?vue&type=style&index=0&id=1b6c3e48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6c3e48",
  null
  
)

export default component.exports